import React from 'react';
import { useTranslation } from 'react-i18next';

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-4">{t('privacy.title')}</h1>
        <h2 className="text-2xl text-[#0A4A7A] mb-8">{t('privacy.company')}</h2>
        <div className="prose prose-lg max-w-none space-y-6">
          <p className="text-gray-700">{t('privacy.intro')}</p>
          <section className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0A4A7A] mb-4">{t('privacy.journalTitle')}</h3>
            <p className="text-gray-700">{t('privacy.journalText')}</p>
          </section>
          <section className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0A4A7A] mb-4">{t('privacy.bookingTitle')}</h3>
            <p className="text-gray-700">{t('privacy.bookingText')}</p>
          </section>
          <section className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0A4A7A] mb-4">{t('privacy.usageTitle')}</h3>
            <p className="text-gray-700 mb-2">{t('privacy.usageIntro')}</p>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>{t('privacy.usage1')}</li>
              <li>{t('privacy.usage2')}</li>
              <li>{t('privacy.usage3')}</li>
            </ul>
            <p className="text-gray-700 mt-4">{t('privacy.usageNote')}</p>
          </section>
          <section className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0A4A7A] mb-4">{t('privacy.securityTitle')}</h3>
            <p className="text-gray-700">{t('privacy.securityText')}</p>
          </section>
          <section className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0A4A7A] mb-4">{t('privacy.contactTitle')}</h3>
            <p className="text-gray-700 mb-4">{t('privacy.contactIntro')}</p>
            <p className="text-gray-700">{t('privacy.company')}<br />E-post: info@varmdohorsel.se<br />Telefon: 072-334 47 74<br />Besöksadress: Gustavsbergs Värdshus, Algatan 3, Våning 1, 134 40 Gustavsberg</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
